import wagesHistoryUrl from './wagesHistory.html';

export default class UserWagesHistoryCtrl {
  wagesHistoryUrl = wagesHistoryUrl;

  constructor(Authentication, Restangular, Utils, UserUtils, $state, $window, user) {
    'ngInject';

    Object.assign(this, { Authentication, Restangular, Utils, UserUtils, $state, $window, user });

    this.wagesReadOnly = !this.UserUtils.canEditUserWages(this.user);
    this.reset();
  }

  reset() {
    this.dirty = false;
    this.historicalWages = this.user.historicalWages.map((item) => ({
      ...item,
      wage: { ...item.wage },
    }));
  }

  filterDeleted(item) {
    return !item.wage.deleted;
  }

  deleteWageRate(wage) {
    wage.deleted = true;
    this.dirty = true;
  }

  async save() {
    const payload = this.historicalWages
      .filter((item) => item.wage.deleted)
      .map((item) => item.wage);

    await this.Restangular.all('labor/wages/user/bulk').customPUT(payload);

    this.reset();
  }
}
